export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7f3401b46ca26980ba7ceb082895ef1905108a26f6&name=sendEvent!'